import { useState, useEffect, useContext } from 'react'
import Crums from '../../common/breadCrums/Crums'
import CatalogItem from '../../common/catalogWrapper/CatalogItem/CatalogItem'
import PageSpinner from '../../common/pageSpinner/PageSpinner'
import classes from './FavoritePage.module.scss'
import { ProfileContext } from '../../../App'
import { useNavigate } from 'react-router-dom'
import {useGetAsics} from "../../hooks/useGetAsics";

const FavoritePage = () => {
   //const context = useContext(ProfileContext)
   const navigate = useNavigate()
   //const [isLoading, setLoading] = useState(true)
   const activeFavorites = localStorage.getItem('favorite')?.split(',') ?? []
   const {data, isLoading} = useGetAsics()
   const activeFavoritesArr = data.filter(item=>activeFavorites.includes(item.id.toString()))

   /*useEffect(() => {
      if (localStorage.getItem('authName') === null || localStorage.getItem('authName') === "") {
         context.storeDispatch({
            type: 'popup_toggle',
            payload: true,
         })
      } else {
         setLoading(true)
      }
   }, [])*/

   //    <div>
   //    <div className={classes.title}>Избранное</div>
   //    <div className={classes.wrapperItem}>
   //       {userData?.length ? (
   //          <>
   //             {userData?.map((item) => (
   //                <CatalogItem {...item} />
   //             ))}
   //          </>
   //       ) : (
   //          <div className={classes.noContent}>
   //             <p>
   //                Выберете предметы на странице{' '}
   //                <span
   //                   onClick={() => {
   //                      navigate('/asic-miners')
   //                      window.location.reload()
   //                   }}
   //                >
   //                   Asic-майнеров
   //                </span>{' '}
   //                что бы добавить в избранное
   //             </p>
   //          </div>
   //       )}
   //    </div>
   // </div>

   return (
      <div className={'container'}>
         <Crums data={[['', 'Избранное']]} />
         <h1 className={classes.title}>Избранное :</h1>
         {activeFavoritesArr.length === 0 && isLoading === false ?
            (<div className={classes.noContent}>
               <p>
                  Выберете предметы на странице{' '}
                  <span
                     onClick={() => {
                        navigate('/asic-miners')
                        window.location.reload()
                     }}
                  >
                     Asic-майнеров
                  </span>{' '}
                  что бы добавить в избранное
               </p>
            </div>) : null
         }

         {isLoading === true ? <PageSpinner /> :
            (<div className={classes.wrapperItem}>
               {activeFavoritesArr.map(element =>
                  <CatalogItem {...element} />
               )} </div>)
         }


      </div>
   )
}

export default FavoritePage
